import React, { useState, useMemo } from "react"

// components
import { Panel } from "components-design-system"
import ActionItemsGrid from "../ActionItemsGrid"
import { PrimeButton } from "components-design-system"

// apis
import { useUserPermissions } from "api/hooks"

const ActionItemsGridWrapper = ({
  type,
  onOpenPanel,
  actionItems = [],
  refetchActionItems = () => {},
  setSelectedActionItem,
  canEditAi,
}) => {
  // local state
  const [activeFilter, setActiveFilter] = useState("all")
  // server state
  const { data: permissions } = useUserPermissions()
  // const deleteActionItem = useDeleteActionItem()

  const gridRef = React.useRef()
  const paginationPageSizeSelector = [10, 20, 50, 100]
  const paginationPageSize = 10
  const domLayout = "autoHeight"

  const actions = useMemo(() => {
    let buttons = []
    if (type === "activity") {
      buttons.push(
        <div
          key={"ai-filters"}
          className="filter-container"
        >
          <PrimeButton
            icon={<i className="fas fa-layer-group" />}
            shape="circle"
            tooltip="All"
            onClick={() => setActiveFilter("all")}
            className={activeFilter === "all" ? "active" : null}
          />
          <PrimeButton
            icon={<i className="fal fa-table" />}
            shape="circle"
            tooltip="Forms"
            onClick={() => setActiveFilter("forms")}
            className={activeFilter === "forms" ? "active" : null}
          />
          <PrimeButton
            icon={<i className="fas fa-file-alt" />}
            shape="circle"
            tooltip="Files"
            onClick={() => setActiveFilter("documents")}
            className={activeFilter === "documents" ? "active" : null}
          />
        </div>
      )
    }

    if (permissions?.["actionitem.create"] && canEditAi !== false) {
      buttons.push(
        <PrimeButton
          key={"add-ai-btn"}
          type="add"
          onClick={() => {
            setSelectedActionItem(null)
            onOpenPanel()
          }}
        >
          Add action item
        </PrimeButton>
      )
    }

    return buttons
  }, [type, permissions, canEditAi])

  return (
    <Panel
      title="ACTION ITEM"
      iconClassName="fas fa-list"
      actions={actions}
      className="action-items-panel"
    >
      <ActionItemsGrid
        type={type}
        actionItems={actionItems}
        activeFilter={activeFilter}
        gridRef={gridRef}
        paginationPageSize={paginationPageSize}
        paginationPageSizeSelector={paginationPageSizeSelector}
        domLayout={domLayout}
        onOpenPanel={onOpenPanel}
        setSelectedActionItem={setSelectedActionItem}
        refetchActionItems={refetchActionItems}
        canEditAi={canEditAi}
      />
    </Panel>
  )
}

export default ActionItemsGridWrapper
